var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dropdown',{staticClass:"bg-white",attrs:{"config":{
        label: 'label',
        trackBy: 'value',
    },"options":_vm.options,"allow-empty":false,"show-icon":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }